import { accessTypes } from '../../utils/AccessTypes';
import api from '../../utils/api';
import { GetResponseAccessTypes } from './types';

export async function getAccessTypes(
  type: string,
): Promise<GetResponseAccessTypes[]> {
  const { data } = await api.get('/accessTypes');

  const types: GetResponseAccessTypes[] = data.map((accessType: string) => ({
    accessType,
    formattedAccessType: accessTypes[accessType as keyof Object],
  }));

  if (type === 'Cliente') {
    return types.filter(item => item.accessType !== 'ADMIN');
  }

  return types;
}
